

















import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import { Company } from '../store/company'
import MachineForm from './MachineForm.vue'
import { Sensor } from '../store/sensor'
import { AddMachine, MachineOverview } from '../store/machine'
import { Alarm } from '../store/alarm'
import { Warning } from '../store/warning'

const company = namespace('company')
const sensor = namespace('sensor')
const machine = namespace('machine')
const alarm = namespace('alarm')
const warning = namespace('warning')
@Component({ components: { MachineForm } })
export default class AddMachineModal extends Vue {
  @machine.Action add!: (machine: AddMachine) => Promise<MachineOverview>
  @sensor.Getter sensors!: Sensor[]
  @alarm.Getter alarms!: Alarm[]
  @warning.Getter warnings!: Warning[]
  @company.Getter companies!: Company[]
  dialog = false

  async addMachine(input: AddMachine) {
    await this.add(input)
    this.dialog = false
  }
}
